import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingPaymentMacos',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/macos/',
    component: () => import('@/modules/macos/layout/LayoutPage.vue'),
    children: [
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/macos/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
